/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Risk } from './Risk';
import { RiskFromJSON, RiskFromJSONTyped, RiskToJSON } from './Risk';

/**
 *
 * @export
 * @interface PaginatedRiskList
 */
export interface PaginatedRiskList {
  /**
   *
   * @type {number}
   * @memberof PaginatedRiskList
   */
  count: number;
  /**
   *
   * @type {string}
   * @memberof PaginatedRiskList
   */
  next?: string | null;
  /**
   *
   * @type {string}
   * @memberof PaginatedRiskList
   */
  previous?: string | null;
  /**
   *
   * @type {Array<Risk>}
   * @memberof PaginatedRiskList
   */
  results: Array<Risk>;
}

/**
 * Check if a given object implements the PaginatedRiskList interface.
 */
export function instanceOfPaginatedRiskList(value: object): value is PaginatedRiskList {
  if (!('count' in value) || value['count'] === undefined) return false;
  if (!('results' in value) || value['results'] === undefined) return false;
  return true;
}

export function PaginatedRiskListFromJSON(json: any): PaginatedRiskList {
  return PaginatedRiskListFromJSONTyped(json, false);
}

export function PaginatedRiskListFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaginatedRiskList {
  if (json == null) {
    return json;
  }
  return {
    count: json['count'],
    next: json['next'] == null ? undefined : json['next'],
    previous: json['previous'] == null ? undefined : json['previous'],
    results: (json['results'] as Array<any>).map(RiskFromJSON),
  };
}

export function PaginatedRiskListToJSON(value?: PaginatedRiskList | null): any {
  if (value == null) {
    return value;
  }
  return {
    count: value['count'],
    next: value['next'],
    previous: value['previous'],
    results: (value['results'] as Array<any>).map(RiskToJSON),
  };
}
